import DateFnsUtils from '@date-io/date-fns'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { MsgAlert } from '@ifca-root/react-component/src/components/others/MsgAlert'
import { Grid, IconButton, MenuItem, TextField } from '@material-ui/core'
import { AddBox, Delete, InfoOutlined } from '@material-ui/icons'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { isBefore } from 'date-fns'
import React, { useState } from 'react'
import { v4 as itemuuid, v4 as uuidv4 } from 'uuid'
import {
  DragNDropList,
  DraggableItem,
  DropableItem,
} from '../../../components/Listing/DraggableItems'

const computeMethods = ['TAX_ON_GROSS', 'TAX_ON_TAXED_PRICE']

type TaxSchemeDialogProps = {
  open: boolean
  onClose: () => void
  detailMode: string
  fields: any
  append: any
  detailIndex: number
  getTaxListing: any[]
  items: any[]
  setItems: any
  isExemptedScheme: boolean
}

export const TaxSchemeDialog: React.FC<TaxSchemeDialogProps> = ({
  open,
  onClose,
  detailMode,
  fields,
  append,
  detailIndex,
  getTaxListing,
  items,
  setItems,
  isExemptedScheme,
}) => {
  const [effectiveDate, setEffectiveDate] = useState<Date | null>(
    detailMode === 'add'
      ? new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
      : fields[fields?.length - 1]?.effectiveDate
  )

  const detailId =
    detailMode === 'add' ? uuidv4() : fields[detailIndex]?.detailId

  const TodayDate = new Date()
  const NATime = new Date()
  const PreviousDate = new Date(new Date().setDate(TodayDate.getDate() - 1))
  const NextDate = new Date(new Date().setDate(TodayDate.getDate() + 1))

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        detailItemId: itemuuid(),
        selectedTax: null,
        computeMethod: '',
        taxOnSeq: [],
        seqNo: items.length + 1,
      },
    ])
  }

  const handleRemove = (index: number) => {
    const newItems = items.filter((_, i) => i !== index)
    setItems(newItems)
  }

  const onDragEnd = (result: any) => {
    const { destination, source } = result
    if (!destination || destination.index === source.index) return

    const reordered = [...items]
    const [movedItem] = reordered.splice(source.index, 1)
    reordered.splice(destination.index, 0, movedItem)
    const reorderedWithIndex = reordered?.map((x, index) => {
      return (x = {
        detailItemId: x.detailItemId,
        selectedTax: x.selectedTax,
        computeMethod: index === 0 ? 'TAX_ON_GROSS' : x.computeMethod,
        taxOnSeq:
          index === 0 ? [] : [...x.taxOnSeq?.filter(y => y < index + 1)],
        seqNo: index + 1,
      })
    })
    setItems(reorderedWithIndex)
  }

  const footerOptions = [
    {
      displayText: 'Cancel',
      props: {
        onClick: () => {
          onClose()
        },
        variant: 'contained',
        color: 'primary',
      },
    },
    {
      displayText: 'Save',
      props: {
        onClick: () => {
          let itemArray: any[] = []

          for (let i = 0; i < items.length; i++) {
            let taxOnSeqInput: any[] = []

            items[i]?.taxOnSeq?.length > 0 &&
              items[i]?.taxOnSeq?.map(x =>
                taxOnSeqInput.push({
                  seqNo: parseFloat(x),
                  taxSchemeDetailItemId: items[x - 1]?.detailItemId,
                })
              )

            itemArray.push({
              detailItemId: items[i]?.detailItemId,
              taxId: items[i]?.selectedTax?.tax_id,
              computeMethod: items[i]?.computeMethod,
              seqNo: items[i]?.seqNo,
              taxOnSeq: taxOnSeqInput?.length > 0 ? taxOnSeqInput : null,
            })
          }

          if (detailMode === 'edit') {
            fields[detailIndex] = {
              detailId,
              effectiveDate,
              taxSchemeDetailItem: itemArray,
            }
          } else {
            append({
              detailId,
              effectiveDate,
              taxSchemeDetailItem: itemArray,
            })
          }

          onClose()
        },
        variant: 'contained',
        color: 'primary',
        disabled:
          !items[0]?.selectedTax ||
          !items[0]?.computeMethod ||
          !effectiveDate ||
          !!items?.find(
            a =>
              a?.computeMethod === 'TAX_ON_TAXED_PRICE' &&
              a?.taxOnSeq?.length === 0
          ),
      },
    },
  ]

  const customCardContentStyle = {
    width: '100%',
    display: 'block',
    margin: 'auto',
  }

  const enumFormatter = (str: string) => {
    return ` ${str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(' ')}`
  }

  return (
    <CommonDialog
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={onClose}
      sections={{
        header: {
          title: 'Tax',
          rightText: detailMode === 'edit' ? 'Edit' : 'New',
        },
        body: () => {
          return (
            <>
              <div className="content-container" style={{ marginTop: '-20px' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    value={effectiveDate}
                    margin="normal"
                    label="Effective Date"
                    required
                    fullWidth
                    onChange={date => setEffectiveDate(date)}
                    minDate={
                      isBefore(new Date(TodayDate), new Date(NATime))
                        ? PreviousDate
                        : NextDate
                    }
                    format="dd/MM/yyyy"
                    style={{ paddingBottom: '20px' }}
                  />
                </MuiPickersUtilsProvider>
              </div>

              <div className="content-container" style={{ marginTop: '-20px' }}>
                <MsgAlert
                  icon={<InfoOutlined />}
                  message={'Drag and drop the item to re-sequence.'}
                />

                <CardContents
                  section={{
                    header: {
                      title: 'Tax Scheme Detail Item',
                      icon: <AddBox />,
                      onClickAction: handleAddItem,
                    },
                  }}
                  style={customCardContentStyle}
                  contentStyle={{ display: 'block' }}
                >
                  {items?.length === 0 ? (
                    <div style={{ width: '100%', justifyContent: 'center' }}>
                      <EmptyList
                        title={'No Records'}
                        subtitle={
                          'Click the add button to create a new record.'
                        }
                      />
                    </div>
                  ) : (
                    <DragNDropList onDragEnd={onDragEnd}>
                      <DropableItem droppableId={'tax_item_list'}>
                        {items.map((item, index) => (
                          <DraggableItem
                            id={item.detailItemId}
                            index={index}
                            draggableId={item.detailItemId}
                            key={item.detailItemId}
                          >
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={1}>
                                {index + 1}.
                              </Grid>
                              <Grid
                                item
                                xs={
                                  item.computeMethod === 'TAX_ON_TAXED_PRICE'
                                    ? 4
                                    : 5
                                }
                              >
                                <Autocomplete
                                  options={getTaxListing}
                                  getOptionLabel={option => option.code}
                                  value={item?.selectedTax || null}
                                  onChange={(e, value) => {
                                    const newArr = [...items]
                                    newArr[index].selectedTax = value
                                    setItems(newArr)
                                  }}
                                  renderOption={(props, option) => {
                                    return (
                                      <div className="content-wrap full">
                                        <div>
                                          <span className="xsTitle">
                                            {props?.code}
                                          </span>
                                        </div>
                                        <div className="desc">
                                          {props?.description}
                                          {props?.is_exempted === true &&
                                            `  (Exempted Tax)`}
                                        </div>
                                      </div>
                                    )
                                  }}
                                  renderInput={params => (
                                    <TextField
                                      {...params}
                                      label="Tax"
                                      variant="standard"
                                      margin="normal"
                                    />
                                  )}
                                  fullWidth
                                />
                              </Grid>
                              <Grid
                                item
                                xs={
                                  item.computeMethod === 'TAX_ON_TAXED_PRICE'
                                    ? 4
                                    : 5
                                }
                              >
                                <TextField
                                  fullWidth
                                  select
                                  label="Compute Method"
                                  margin="normal"
                                  value={items[index].computeMethod}
                                  name="classType"
                                  autoComplete="off"
                                  onChange={event => {
                                    const newArr = [...items]
                                    newArr[index].computeMethod =
                                      event?.target?.value
                                    setItems(newArr)
                                  }}
                                >
                                  {computeMethods
                                    ?.filter(x => {
                                      if (index === 0)
                                        return x === 'TAX_ON_GROSS'
                                      else return x
                                    })
                                    ?.map(option => (
                                      <MenuItem key={option} value={option}>
                                        <span>{enumFormatter(option)}</span>
                                      </MenuItem>
                                    ))}
                                </TextField>
                              </Grid>
                              {item.computeMethod === 'TAX_ON_TAXED_PRICE' && (
                                <Grid item xs={2}>
                                  <Autocomplete
                                    multiple
                                    options={Array.from(
                                      { length: index },
                                      (_, i) => (i + 1).toString()
                                    )}
                                    value={item.taxOnSeq}
                                    onChange={(e, value) => {
                                      const newArr = [...items]
                                      newArr[index].taxOnSeq = value
                                      setItems(newArr)
                                    }}
                                    renderInput={params => (
                                      <TextField
                                        {...params}
                                        label="Tax On Seq"
                                        variant="standard"
                                      />
                                    )}
                                  />
                                </Grid>
                              )}
                              <Grid item xs={1}>
                                <IconButton onClick={() => handleRemove(index)}>
                                  <Delete style={{ color: 'red' }} />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </DraggableItem>
                        ))}
                      </DropableItem>
                    </DragNDropList>
                  )}
                </CardContents>
              </div>
            </>
          )
        },
        footer: { actions: footerOptions },
      }}
    />
  )
}
